import { create } from "zustand";

type FormErrors = Record<string, string | undefined>;

export interface FormValues {
	firstName: string;
	lastName: string;
	email: string;
	state: string;
	loanAmount: string;
	phone: string;
	loanPurpose: string;
	loanType: string;
	assetType: string;
	purchaseStage: string;
	assetAge: string;
	purchaseFrom: string;
	livingStatus: string;
	employmentStatus: string;
	abnStatus: string;
	gstStatus: string;
	combinedIncome: string;
	creditHistory: string;
	// Business Loan
	businessAbnStatus: string;
	// Mortgages
	purchasePrice: string;
	depositAmount: string;
	firstHomeBuyer: string;
	propertyPurpose: string;
	fixedRate: string;
	interestRate: string;
	lenderName: string;
	propertyValue: string;
	currentMortgage: string;
	refinancePurpose: string;
}

export const initialFormValues: FormValues = {
	firstName: "",
	lastName: "",
	email: "",
	state: "",
	loanAmount: "",
	phone: "",
	loanPurpose: "",
	loanType: "",
	assetType: "",
	purchaseStage: "",
	assetAge: "",
	purchaseFrom: "",
	livingStatus: "",
	employmentStatus: "",
	abnStatus: "",
	gstStatus: "",
	combinedIncome: "",
	creditHistory: "",
	// Business Loan
	businessAbnStatus: "",
	// Mortgages
	purchasePrice: "",
	depositAmount: "",
	firstHomeBuyer: "",
	propertyPurpose: "",
	fixedRate: "",
	interestRate: "",
	lenderName: "",
	propertyValue: "",
	currentMortgage: "",
	refinancePurpose: "",
};

export interface FormData {
	formValues: FormValues;
	formErrors: FormErrors;

	// Initializes formValues
	resetFormValues: () => void;

	// Setter function to update specific fields
	setFormValue: (field: keyof FormValues, value: string) => void;
	setFormError: (field: string, message: string) => void;
	clearFormError: (field: string) => void;
}

export const useFormData = () =>
	create<FormData>((set) => ({
		formValues: { ...initialFormValues },
		formErrors: {},

		resetFormValues: () =>
			set(() => ({
				formValues: { ...initialFormValues },
				formErrors: {},
			})),

		// Dynamic setter function to update form fields
		setFormValue: (field, value) =>
			set((state) => ({
				formValues: {
					...state.formValues,
					[field]: value,
				},
				formErrors: {
					...state.formErrors,
					[field]: undefined,
				},
			})),

		setFormError: (field, message) =>
			set((state) => ({
				formErrors: {
					...state.formErrors,
					[field]: message,
				},
			})),

		clearFormError: (field) =>
			set((state) => ({
				formErrors: {
					...state.formErrors,
					[field]: undefined,
				},
			})),
	}));
